module.exports = __webpack_public_path__ + "img/appointment_order.b7e6ef81.png";